<div class="d-flex">

  <div class="w50 p16">
    <form [formGroup]="form">
      <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
    </form>
    <h3 class="text-danger" i18n="@@mark-available-modules">Mark available modules !</h3>

    <div class="d-flex">
      <div class="f-gr-1"></div>
      <button type="button"
              [disabled]="form.invalid || modules.length === 0"
              (click)="save(model)" mat-raised-button color="primary" i18n="@@save-license">Save license</button>
    </div>
  </div>

  <div class="w50 p16">
    <app-module-list (moduleChangeEvent)="moduleChange($event)"></app-module-list>
  </div>

</div>
